(function(){
  'use strict';
  var drawerId = 'adams-collections-drawer';
  var openSelector = '[data-adams-mobile-menu-open], .adams-mobile-menu-button-text';

  function drawer(){ return document.getElementById(drawerId); }
  function panel(){ var d = drawer(); return d ? d.querySelector('.adams-collections-drawer__panel') : null; }
  function buttons(){ return Array.prototype.slice.call(document.querySelectorAll(openSelector)); }

  function setExpanded(value){ buttons().forEach(function(b){ b.setAttribute('aria-expanded', value ? 'true' : 'false'); }); }

  function openMenu(e){
    if(e){ e.preventDefault(); e.stopPropagation(); if(e.stopImmediatePropagation) e.stopImmediatePropagation(); }
    var d = drawer();
    if(!d) return false;
    d.classList.add('is-open');
    d.setAttribute('aria-hidden','false');
    document.documentElement.classList.add('adams-collections-menu-open');
    document.body.classList.add('adams-collections-menu-open');
    setExpanded(true);
    return false;
  }

  function closeMenu(e){
    if(e){ e.preventDefault(); e.stopPropagation(); if(e.stopImmediatePropagation) e.stopImmediatePropagation(); }
    var d = drawer();
    if(!d) return false;
    d.classList.remove('is-open');
    d.setAttribute('aria-hidden','true');
    document.documentElement.classList.remove('adams-collections-menu-open');
    document.body.classList.remove('adams-collections-menu-open');
    setExpanded(false);
    return false;
  }

  function isOpen(){ var d = drawer(); return !!(d && d.classList.contains('is-open')); }

  function bind(){
    buttons().forEach(function(btn){
      btn.type = 'button';
      btn.onclick = openMenu;
      btn.addEventListener('click', openMenu, true);
      btn.addEventListener('touchend', openMenu, true);
    });
    var d = drawer();
    if(!d) return;

    // Keep every touch/scroll/click inside the white drawer from reaching theme scripts.
    var p = panel();
    if(p){
      ['click','touchstart','touchmove','touchend','mousedown','mouseup','pointerdown','pointerup'].forEach(function(evt){
        p.addEventListener(evt, function(ev){ ev.stopPropagation(); }, true);
      });
    }

    d.addEventListener('click', function(e){
      if(e.target === d) return closeMenu(e); // only dark outside area closes
      var close = e.target.closest && e.target.closest('.adams-collections-drawer__close');
      if(close) return closeMenu(e);
      var link = e.target.closest && e.target.closest('.adams-collections-drawer__nav a[href]');
      if(link){
        e.preventDefault(); e.stopPropagation(); if(e.stopImmediatePropagation) e.stopImmediatePropagation();
        window.location.href = link.href;
        return false;
      }
    }, true);

    d.addEventListener('touchend', function(e){
      if(e.target === d) return closeMenu(e); // outside only
    }, true);
  }

  document.addEventListener('keydown', function(e){ if(e.key === 'Escape' && isOpen()) closeMenu(e); }, true);
  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', bind); else bind();
  window.addEventListener('load', bind);
})();
